import React from 'react';
import { Radio, Row, Col, Form } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { I18n } from '@aws-amplify/core';

import { WORK_ORGANIZATION_OPTIONS } from '@/components/views/Report/KimLhc/Constants';

import * as S from './styles';

interface TemporalDistributionFormItemProps {
	fieldName: NamePath;
}

export function TemporalDistributionFormItem({ fieldName }: Readonly<TemporalDistributionFormItemProps>) {
	return (
		<Form.Item
			name={fieldName}
			rules={[{ required: true, message: I18n.get('The field requires an answer') }]}
			style={{ marginBottom: 0 }}
		>
			<Radio.Group style={{ width: '100%' }}>
				<S.RadioOptionsContainer>
					{WORK_ORGANIZATION_OPTIONS.temporal_distribution.map((option) => (
						<Radio key={option.value} value={option.value}>
							<Row gutter={[0, 4]}>
								<Col span={24}>
									<S.FactorDescriptionHeader>{I18n.get(option.titleKey)}</S.FactorDescriptionHeader>
								</Col>
								<Col span={24}>
									<S.FactorDescriptionText>{I18n.get(option.descriptionKey)}</S.FactorDescriptionText>
								</Col>
							</Row>
						</Radio>
					))}
				</S.RadioOptionsContainer>
			</Radio.Group>
		</Form.Item>
	);
}
